(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["wt-shop-navigation"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wt-shop-navigation')) {
    customElements.define('wt-shop-navigation', class extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.root = this.querySelector('.wt-shop-menu');
        this.ranges = [...this.querySelectorAll('.wt-shop-range')];
        this.hover = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
        const setOpen = (details, open) => {
          details.open = open;
          details.querySelector(':scope > summary').setAttribute('aria-expanded', String(open));
        };
        this.close = () => {
          clearTimeout(this.closeTimer);
          this.ranges.forEach(range => setOpen(range, false));
          setOpen(this.root, false);
        };
        this.addEventListener('pointerenter', event => {
          clearTimeout(this.closeTimer);
          if (this.hover.matches && event.pointerType !== 'touch') setOpen(this.root, true);
        }, options);
        this.addEventListener('pointerleave', () => {
          if (!this.hover.matches) return;
          this.closeTimer = setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
          }, 160);
        }, options);
        this.ranges.forEach(range => {
          range.addEventListener('pointerenter', event => {
            if (this.hover.matches && event.pointerType !== 'touch') setOpen(range, true);
          }, options);
          range.addEventListener('toggle', () => {
            range.querySelector(':scope > summary').setAttribute('aria-expanded', String(range.open));
            if (!range.open) return;
            this.ranges.filter(other => other !== range).forEach(other => setOpen(other, false));
            range.classList.remove('wt-shop-range--left');
            const bounds = range.querySelector('.wt-shop-menu__finishes').getBoundingClientRect();
            if (bounds.right > window.innerWidth - 12) range.classList.add('wt-shop-range--left');
          }, options);
        });
        this.root.addEventListener('toggle', () => {
          this.root.querySelector(':scope > summary').setAttribute('aria-expanded', String(this.root.open));
          if (!this.root.open) this.ranges.forEach(range => setOpen(range, false));
        }, options);
        this.addEventListener('keyup', event => {
          if (event.key !== 'Escape') return;
          event.stopPropagation();
          const opened = event.target.closest('details[open]');
          if (!opened) return;
          setOpen(opened, false);
          opened.querySelector(':scope > summary').focus();
        }, { ...options, capture: true });
        document.addEventListener('pointerdown', event => {
          if (!this.contains(event.target)) this.close();
        }, options);
        this.hover.addEventListener('change', this.close, options);
      }
      disconnectedCallback() {
        clearTimeout(this.closeTimer);
        this.controller.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
